"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPassStatusRendererFactory = void 0;
const GradingMethodType_1 = __importDefault(require("@opsbase/lib-grading/GradingMethodType"));
const PassStatusChip_1 = __importDefault(require("@opsbase/web-chips/PassStatusChip"));
const react_1 = __importDefault(require("react"));
const OpPassStatusRendererFactory = () => (op) => {
    var _a;
    if (!op.gradingMethod || ((_a = op.gradingMethod) === null || _a === void 0 ? void 0 : _a.gradingMethodType) === GradingMethodType_1.default.NONE)
        return null;
    return react_1.default.createElement(PassStatusChip_1.default, { status: op.passFailStatus });
};
exports.OpPassStatusRendererFactory = OpPassStatusRendererFactory;
exports.default = exports.OpPassStatusRendererFactory;
